import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import PropTypes from 'prop-types';

AgencyCardValue.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  unit: PropTypes.string,
  icon: PropTypes.string,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  nameColor: PropTypes.string,
  valueColor: PropTypes.string,
  unitColor: PropTypes.string,
  dividerColor: PropTypes.string,
};

AgencyCardValue.defaultProps = {
  backgroundColor: '#fff',
  nameColor: AppColors.gray[600],
  valueColor: AppColors.gray[800],
  unitColor: AppColors.gray[600],
  dividerColor: AppColors.gray[300],
};

function AgencyCardValue(props) {
  // MARK: ---- PROPERTIES ----
  const {
    name,
    value,
    unit,
    icon,
    color,
    backgroundColor,
    nameColor,
    valueColor,
    unitColor,
    dividerColor,
  } = props;

  return (
    <div
      className="overflow-hidden position-relative"
      style={{
        border: `1px solid ${AppColors.gray[300]}`,
        borderRadius: '10px',
        backgroundColor: color,
      }}
    >
      <div
        style={{
          backgroundColor: backgroundColor,
          borderBottomLeftRadius: '10px',
          borderBottomRightRadius: '10px',
          marginBottom: '5px',
        }}
      >
        {/* header */}
        <div
          className="px-5 py-5"
          style={{
            borderBottom: `1px dashed ${dividerColor}`,
          }}
        >
          <span style={UIHelper.buildFontStyle('500', '13px', nameColor)}>{name}</span>
        </div>
        {/* body */}
        <div className="px-4 py-3 d-flex flex-column">
          <span style={UIHelper.buildFontStyle('700', '20px', valueColor)}>{value}</span>
          <span style={UIHelper.buildFontStyle('600', '15px', unitColor)}>{unit}</span>
        </div>
      </div>

      {/* icon */}
      {icon && (
        <div
          className="position-absolute rounded-circle"
          style={{
            width: '100px',
            height: '100px',
            backgroundColor: color,
            top: '-20px',
            right: '-20px',
            opacity: 0.15,
          }}
        >
          <i
            className={`w-100 h-100 fa-fw fa-3x ${icon}`}
            style={{ color: '#fff', paddingTop: '33px', paddingRight: '10px' }}
          />
        </div>
      )}
    </div>
  );
}

export default AgencyCardValue;
